import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import AllianceManagerServices from '../../services/API/AllianceManager';

const AuditLogModal = ({ show, handleHide, service_id }) => {
  const [loading, setLoading] = useState(false);
  const [auditLogs, setAuditLogs] = useState([]);

  useEffect(() => {
    getAuditLogs();
  }, [service_id]);

  const getAuditLogs = async () => {
    setLoading(true);
    try {
      const response = await AllianceManagerServices.getActivityLogs(service_id);
      setAuditLogs(response?.data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      animation={false}
      onHide={handleHide}
      dialogClassName="modal-xl"
    >
      <Modal.Header closeButton>
        <h3 className="modal-title">Audit Trail</h3>
      </Modal.Header>
      <Modal.Body style={{ height: "auto" }}>
        {loading ? (
          <div className="d-flex justify-content-center my-3">Loading...</div>
        ) : (
          <div className="table-responsive">
            <table
              className="table table-bordered table-hover table-striped"
              style={{ minWidth: "100%" }}
            >
              <thead className="thead-dark">
                <tr>
                  <th style={{ width: "5%" }}>S. No.</th>
                  <th style={{ width: "20%" }}>User</th>
                  <th style={{ width: "30%" }}>Activity</th>
                  {/* <th style={{ width: "25%" }}>Document Name</th> */}
                  <th style={{ width: "20%" }}>Date & Time</th>
                </tr>
              </thead>
              <tbody>
                {auditLogs.filter((log) => log?.user_name !== "Unknown").length ? (
                  auditLogs.filter((log) => log?.user_name !== "Unknown").map((log, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td style={{ wordWrap: "break-word" }}>{log?.user_name || "-"}</td>
                      <td style={{ wordWrap: "break-word" }}>{log?.document_name ? log?.status + " - " + log?.document_name : log?.status}</td>
                      <td style={{ wordWrap: "break-word" }}>
                        {log?.created_at ? moment(log.created_at).format("DD-MM-YY hh:mm A") : "-"}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default AuditLogModal;
